import React from "react";
import { useHistory } from "react-router-dom";
import { User } from "../../storage/store";
import AppDeviceCard from "./app/AppDeviceCard";
import { DEVICE_TYPES } from "../../constants/devices";

// Security alarm (WZLTEG_1): the card opens the arm and disarm controls. It has no
// on/off state, so, as in the app, the card always shows its red with white text;
// the shade follows isClosed, as the app's colour table does.
export const SecurityDeviceCard = ({ props }) => {
  const device = props;
  const navigate = useHistory();

  return (
    <AppDeviceCard
      name={device.name}
      floor={device.floor}
      room={device.room}
      timeStamp={device.props?.timeStamp}
      type={DEVICE_TYPES.SECURITY_ALARM}
      active={device.props?.state === true}
      colorActive={Boolean(device.props?.isClosed)}
      alwaysColoured
      onOpen={() => navigate.push("/device", { data: device, propertyId: User.getPropertyId() })}
    />
  );
};
